export const AUTH_CACHE_KEYS = {
  KEYCLOAK_PROFILE: 'keycloak_profile'
} as const;
